import { render, staticRenderFns } from "./custSelect.vue?vue&type=template&id=b6703612&scoped=true&"
import script from "./custSelect.vue?vue&type=script&lang=js&"
export * from "./custSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6703612",
  null
  
)

export default component.exports